import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline, sfSub } from './sectionHelpers';

const PricingTable: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const tiers = (c.tiers || []) as Array<{ name: string; price: string; period: string; description: string; features: string; cta_text?: string; cta_url?: string; highlighted?: string }>;

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <InlineEditText
            tag="h2"
            controlKey="headline"
            style={{ fontSize: '2.5rem', letterSpacing: '-0.025em', marginBottom: 12 }}
          >
            {sfHeadline(c, 'Pricing')}
          </InlineEditText>
          {(sfSub(c) !== undefined || true) && (
            <InlineEditText
              tag="p"
              controlKey="subheadline"
              style={{ fontSize: '1.125rem', color: 'var(--brand-text-light, #64748b)', maxWidth: 640, margin: '0 auto' }}
            >
              {sfSub(c, 'Choose the plan that works for you')}
            </InlineEditText>
          )}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(tiers.length, 3)}, 1fr)`, gap: 24 }}>
          {tiers.map((t, i) => {
            const highlighted = String(t.highlighted || 'false').toLowerCase() === 'true';
            const features = typeof t.features === 'string' ? t.features.split(',') : (Array.isArray(t.features) ? t.features : []);
            return (
              <div key={i} style={{
                background: 'var(--brand-bg, #fff)', border: highlighted ? '2px solid var(--brand-primary, #2563eb)' : '1px solid rgba(0,0,0,0.08)',
                borderRadius: 12, padding: 32, textAlign: 'center',
                boxShadow: highlighted ? '0 20px 25px -5px rgba(0,0,0,0.08), 0 8px 10px -6px rgba(0,0,0,0.04)' : '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -2px rgba(0,0,0,0.05)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                ...(highlighted ? { transform: 'scale(1.05)' } : {}),
              }}>
                <h3 style={{ marginBottom: 8 }}>{t.name}</h3>
                <p style={{ color: 'var(--brand-text-light, #64748b)', marginBottom: 16, fontSize: '0.875rem' }}>{t.description}</p>
                <div style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 4, color: 'var(--brand-text, #1e293b)' }}>{t.price}</div>
                <div style={{ color: 'var(--brand-text-light, #64748b)', marginBottom: 24 }}>{t.period}</div>
                <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', marginBottom: 24 }}>
                  {features.filter(Boolean).map((f: string, fi: number) => (
                    <li key={fi} style={{ padding: '8px 0', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                      &#10003; {typeof f === 'string' ? f.trim() : f}
                    </li>
                  ))}
                </ul>
                <a href={t.cta_url || '#'} className="sb-cta-btn" style={{
                  display: 'block', padding: '12px 24px', borderRadius: 6,
                  background: 'var(--brand-primary, #1a365d)', color: '#fff',
                  fontWeight: 600, textDecoration: 'none', textAlign: 'center',
                }}>
                  {t.cta_text || 'Get Started'}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default PricingTable;
